<template>
  <div class="col">
    <div class="row">
      <div class="col-8">
        <SectionTitle
          :content="
            'Evaluación(es) que Recomienda(n) el Servicio (Discusión de Evaluación)'
          "
          :has-line="true"
        />
      </div>
      <input
        id="file"
        ref="file"
        type="file"
        style="display:none;"
        accept="application/pdf"
        @change="uploadDocument(selectedEvaluationtoUpload, $refs.file)"
      />
      <div class="col-4 text-right pt-0">
        <ActionButton
          v-if="isDraft"
          class="mr-2"
          variant="dark"
          type="button"
          i="fas fa-file-alt"
          @click="goToEvaluationDiscussion"
        >
          Discusión de Evaluaciones
        </ActionButton>
      </div>
      <div v-if="showResultSummaryWarning" class="col-12">
        <Error :message="resultSummaryWarningMessage" is-alert-mode />
      </div>
    </div>
    <div class="container-table-striped w-100 mt-4">
      <div class="table-hover">
        <table class="table content-table-striped table-h">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-1" />
              <th class="col-3 text-left bold">
                Evaluación
              </th>
              <th class="col-3 text-left bold">
                Fecha
              </th>
              <th class="col-3 text-left bold">
                Administrada por
              </th>
              <th class="col-2" />
            </tr>
          </thead>
          <tbody v-if="rows.length > 0">
            <tr v-for="row in rows" :key="row.id" class="row">
              <td class="col-md-1">
                <div class="input-group">
                  <input
                    :id="'chk' + row.disciplineTypeId"
                    v-model="row.isSelected"
                    :name="'chk' + row.disciplineTypeId"
                    :value="row.isSelected"
                    type="checkbox"
                    class="option-input checkbox"
                    :checked="row.isSelected"
                    :disabled="disabledAll"
                  />
                  <label
                    :for="'chk' + row.disciplineTypeId"
                    class="checkbox-label pl-3 pr-4"
                  >
                    <span
                      v-if="
                        row.isApprovedByParentFlag != null &&
                          row.studentEvaluationsDocumentIds != null &&
                          row.isApprovedByParentFlag == true
                      "
                    >
                      <i class="ic-check" />
                    </span>
                  </label>
                </div>
              </td>
              <td class="col-md-3 text-left">
                <b class="ml-3">
                  <span>{{ row.disciplineTypeName }}</span>
                </b>
                <Error
                  v-if="
                    row.isApprovedByParentFlag == null ||
                      row.isApprovedByParentFlag == false ||
                      row.studentEvaluationsDocumentIds == null
                  "
                  is-alert-mode
                  :message="messageAlert(row)"
                />
              </td>
              <td class="col-md-3 text-left">
                <div class="ml-3">
                  <span>{{ row.evaluationDate | intformatDate }}</span>
                </div>
              </td>
              <td class="col-md-3 text-left">
                <div class="ml-3">
                  <span>{{ row.evaluationAdministeredBy }}</span>
                </div>
              </td>
              <td class="col-md-2 text-right">
                <button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu pb-0 dropdown-menu-right">
                  <a
                    v-if="
                      !disabledAll &&
                        (row.studentEvaluationsDocumentIds == null ||
                          row.studentEvaluationsDocumentIds == '')
                    "
                    class="drop-item"
                    href="#"
                    @click="beforeUploadDocument($event, row, $refs.file)"
                  >
                    <i class="fas fa-plus-square text-green pr-2" />
                    <span>Añadir Documento</span>
                  </a>
                  <a
                    v-if="
                      row.studentEvaluationsDocumentIds != null &&
                        row.isApprovedByParentFlag
                    "
                    class="drop-item cursor"
                    href="#"
                    @click="
                      downloadDocuments(row.studentEvaluationsDocumentIds)
                    "
                  >
                    <i class="fas fa-file-search text-green pr-2" />
                    <span>Ver Documento</span>
                  </a>
                  <a
                    class="drop-item"
                    href="#"
                    data-toggle="modal"
                    data-backdrop="static"
                    data-target="#modalEval"
                    :disabled="disabledAll"
                    @click="getHistoryEvaluations(row.disciplineTypeId)"
                  >
                    <i class="fas fa-folder-open text-green pr-2" />
                    <span>Ver Historial de Evaluación</span>
                  </a>
                </div>
              </td>
            </tr>
            <!-- <tr class="row"
              v-if="rows.length>0">
            <td class="col text-right">
              <button class="btn btn-action btn-info-darker btn-darkgrey evaluation-box"
                      @click="goBack"
                      :disabled="disabledAll">
                <i class="fas fa-file-alt pr-1"></i>Discusión de evaluaciones
              </button>
            </td>
          </tr> -->
          </tbody>
        </table>
        <Error
          v-if="warningMsg && rows.length == 0"
          :message="warningMsg"
          is-alert-mode
        />
      </div>
      <!-- Modal -->
      <HistoryPopup
        id="modalEval"
        title="Historial de Evaluación"
        icon-title="fas fa-save"
        column-one-name="evaluationDate"
        column-one-title="Fecha"
        column-two-name="evaluationAdministeredBy"
        column-two-title="Administrada Por"
        :items="currentHistoryEvaluation"
      >
        <div slot="sub-title">
          <strong>Evaluación:</strong>
          <span>Historial de Evaluación</span>
        </div>
      </HistoryPopup>
    </div>
  </div>
</template>

<script>
import "@/assets/css/component/checkbox.css";
import store from "@/store/index";
import alert from "@/mixin/alert.mixin";
import mixWait from "@/mixin/loading.mixin";
import { HistoryPopup } from "@/components/pei/shared";
import resourcesService from "@/services/resources.js";
import moment from "moment";
import { SectionTitle } from "@/components/pei/shared";
import peiStatuses from "@/utils/constants/pei/peiStatus.js";
import general from "@/services/pei/general";
import Error from "@/components/common/Error";
import ActionButton from "@/components/common/ActionButton";
import TabAliasEnum from "@/components/pei/programservice/enum/TabAliasEnum";

export default {
  name: "ServiceEvaluation",
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    disabledAll: {
      type: Boolean,
      default: () => false
    },
    warningMsg: {
      type: String,
      default: () => null
    },
    uploadDocument: {
      type: Function,
      default: () => null
    },
    hasResultSummary: {
      type: Boolean,
      default: () => false
    },
    programServiceAreaId: {
      type: [Number, String],
      default: null
    }
  },
  mixins: [mixWait, alert],
  filters: {
    intformatDate(value, format = null) {
      if (value) {
        return moment(value)
          .locale("es-PR")
          .format(format == null ? "DD/MMM/YYYY" : format);
      }
    }
  },
  data() {
    return {
      currentHistoryEvaluation: [],
      selectedEvaluationtoUpload: [],
      titleDisciplineName: "",
      resources: [],
      peiStatus: store.getters.SelectedPeiStatus
    };
  },
  computed: {
    isDraft() {
      const self = this;
      const isdraft = self.peiStatus == peiStatuses.Borrador;
      return isdraft;
    },
    showResultSummaryWarning() {
      return (
        this.hasResultSummary &&
        this.programServiceAreaId &&
        this.programServiceAreaId !== ""
      );
    },
    resultSummaryWarningMessage() {
      const route = this.$router.resolve(
        `/pei/addprogramservice?programservicearea=${this.programServiceAreaId}&tab=${TabAliasEnum.ResultSummary}`
      );
      const absoluteURL = new URL(route.href, window.location.origin).href;

      let message = `La terapia cuenta con un resumen de servicios. <a style="color: #af6708; font-weight: bold;" href="${absoluteURL}">Presione aquí</a> para ver el mismo.`;

      return message;
    }
  },
  methods: {
    onAddClickHandler() {
      this.$emit("on-add");
    },
    beforeUploadDocument(evnt, paramStudentEval, file) {
      evnt.preventDefault();
      this.selectedEvaluationtoUpload = paramStudentEval;
      file.click();
    },
    messageAlert(item) {
      if (item.createDate >= item.isApprovedByParentStartDate) {
        if (item.isApprovedByParentFlag == undefined)
          return this.resources["22142"];
        if (item.isApprovedByParentFlag == false)
          return this.resources["22141"];
        if (item.studentEvaluationsDocumentIds == null)
          return this.resources["22125"];
      } else {
        if (item.isApprovedByParentFlag == undefined)
          return this.resources["22142"];
        if (item.studentEvaluationsDocumentIds == null)
          return this.resources["22125"];
      }
      return "";
    },
    async getHistoryEvaluations(disciplineTypeId) {
      try {
        let response = await this.$ApiGet(
          `api/pei/evaluationhistory/${store.getters.SelectedStudent.studentId}/${disciplineTypeId}`
        );
        this.currentHistoryEvaluation = response.data;
        for (let ii = 0; ii < this.currentHistoryEvaluation.length; ii++) {
          this.currentHistoryEvaluation[ii].evaluationDate = moment(
            this.currentHistoryEvaluation[ii].evaluationDate
          )
            .locale("es-PR")
            .format("DD/MMM/YYYY");
        }
        this.titleDisciplineName = response.data[0].disciplineName;
      } catch {
        alert.methods.ShowAlertModal(
          "Lo sentimos",
          "Ocurrio un error inesperado",
          "error",
          null
        );
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        "22125",
        "22141",
        "22142"
      ]);
    },
    async downloadDocuments(documentIds) {
      if (!documentIds) {
        this.ShowToast(
          "Lo sentimos",
          "No se han encontrado documentos.",
          "error"
        );
        return;
      }
      const documents = documentIds.split(",");

      documents.forEach(async docId => {
        await general.downloadDocumentByAttachmentId(docId);
      });
    },
    async getListOfDocumentForDownload(studentEvaluationId) {
      try {
        const studentSieId = store.getters.SelectedStudent.studentId;
        const { data: resp } = await this.$ApiGet(
          `api/studentevaluation/${studentSieId}/documents/${studentEvaluationId}`
        );
        return resp;
      } catch ({ response: error }) {
        alert.methods.ShowAlertModal(
          "Lo sentimos",
          error.data.message,
          "error",
          null
        );
        return [];
      }
    },
    goBack() {
      const self = this;
      self.$root.$router.push("/pei/detail?tab=Tab8");
    },
    goToEvaluationDiscussion() {
      let studentSieId = store.getters.SelectedStudent.studentId;
      let path = `/student/evaluationdiscuss/${studentSieId}`;
      this.$router.push(path);
    }
  },
  mounted() {},
  components: {
    Error,
    HistoryPopup,
    SectionTitle,
    ActionButton
  },
  created() {
    this.loadResources();
  }
};
</script>

<style scoped>
.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.evaluation-box {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.evaluation-box i {
  margin-right: 5px;
}
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.main-title {
  text-align: left;
  font: Bold 18px/29px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.btn.btn-action.btn-info-darker.btn-darkgrey {
  font-weight: 400;
}
</style>
